import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../../../shared/base-service/base-api.service';
import { AircraftSearchCriteria } from './aircraft-search-criteria.model';
import { AircraftFleetSearchResults } from './aircraft-fleet-search-results.model';

@Injectable()
export class AircraftSearchService extends BaseApiService {
    public search = (aircraftSearchCriteria: AircraftSearchCriteria): Observable<any> => this.post('Aircraft/Aircraft/Search', aircraftSearchCriteria);

    public searchCustomerFleets = (customerNumberId: number): Observable<{result: AircraftFleetSearchResults[]}> => this.get(`Aircraft/Fleet/${customerNumberId}/Search`);
}
